export default "__VITE_ASSET__BplNGUhm__"